// CWE Top 25 Most Dangerous Software Weaknesses (2024)
// Source: https://cwe.mitre.org/top25/archive/2024/2024_top25_list.html
// Based on 31,770 CVE records from 2023-2024

import { Top25Entry } from '../lib/types';

export const TOP_25_2024: Top25Entry[] = [
  {
    rank: 1,
    cweId: 'CWE-79',
    name: 'Improper Neutralization of Input During Web Page Generation (Cross-site Scripting)',
    score: 45.54,
    cveCount: 4442,
    avgCVSS: 6.19,
  },
  {
    rank: 2,
    cweId: 'CWE-787',
    name: 'Out-of-bounds Write',
    score: 43.67,
    cveCount: 3842,
    avgCVSS: 7.28,
  },
  {
    rank: 3,
    cweId: 'CWE-89',
    name: 'Improper Neutralization of Special Elements used in an SQL Command (SQL Injection)',
    score: 34.27,
    cveCount: 1467,
    avgCVSS: 8.73,
  },
  {
    rank: 4,
    cweId: 'CWE-22',
    name: 'Improper Limitation of a Pathname to a Restricted Directory (Path Traversal)',
    score: 24.66,
    cveCount: 819,
    avgCVSS: 8.59,
  },
  {
    rank: 5,
    cweId: 'CWE-352',
    name: 'Cross-Site Request Forgery (CSRF)',
    score: 23.08,
    cveCount: 345,
    avgCVSS: 8.35,
  },
  {
    rank: 6,
    cweId: 'CWE-434',
    name: 'Unrestricted Upload of File with Dangerous Type',
    score: 20.26,
    cveCount: 322,
    avgCVSS: 8.44,
  },
  {
    rank: 7,
    cweId: 'CWE-125',
    name: 'Out-of-bounds Read',
    score: 18.64,
    cveCount: 2117,
    avgCVSS: 5.51,
  },
  {
    rank: 8,
    cweId: 'CWE-78',
    name: 'Improper Neutralization of Special Elements used in an OS Command (OS Command Injection)',
    score: 16.44,
    cveCount: 415,
    avgCVSS: 9.32,
  },
  {
    rank: 9,
    cweId: 'CWE-20',
    name: 'Improper Input Validation',
    score: 15.98,
    cveCount: 2318,
    avgCVSS: 6.65,
  },
  {
    rank: 10,
    cweId: 'CWE-862',
    name: 'Missing Authorization',
    score: 15.60,
    cveCount: 1168,
    avgCVSS: 7.07,
  },
  {
    rank: 11,
    cweId: 'CWE-476',
    name: 'NULL Pointer Dereference',
    score: 15.34,
    cveCount: 1625,
    avgCVSS: 5.83,
  },
  {
    rank: 12,
    cweId: 'CWE-287',
    name: 'Improper Authentication',
    score: 15.15,
    cveCount: 1117,
    avgCVSS: 7.02,
  },
  {
    rank: 13,
    cweId: 'CWE-798',
    name: 'Use of Hard-coded Credentials',
    score: 13.84,
    cveCount: 262,
    avgCVSS: 8.75,
  },
  {
    rank: 14,
    cweId: 'CWE-918',
    name: 'Server-Side Request Forgery (SSRF)',
    score: 13.74,
    cveCount: 306,
    avgCVSS: 8.63,
  },
  {
    rank: 15,
    cweId: 'CWE-119',
    name: 'Improper Restriction of Operations within the Bounds of a Memory Buffer',
    score: 13.60,
    cveCount: 819,
    avgCVSS: 7.45,
  },
  {
    rank: 16,
    cweId: 'CWE-416',
    name: 'Use After Free',
    score: 12.89,
    cveCount: 1151,
    avgCVSS: 7.20,
  },
  {
    rank: 17,
    cweId: 'CWE-863',
    name: 'Incorrect Authorization',
    score: 11.97,
    cveCount: 969,
    avgCVSS: 6.91,
  },
  {
    rank: 18,
    cweId: 'CWE-94',
    name: 'Improper Control of Generation of Code (Code Injection)',
    score: 11.72,
    cveCount: 436,
    avgCVSS: 8.33,
  },
  {
    rank: 19,
    cweId: 'CWE-502',
    name: 'Deserialization of Untrusted Data',
    score: 10.29,
    cveCount: 237,
    avgCVSS: 8.82,
  },
  {
    rank: 20,
    cweId: 'CWE-77',
    name: 'Improper Neutralization of Special Elements used in a Command (Command Injection)',
    score: 9.45,
    cveCount: 208,
    avgCVSS: 9.26,
  },
  {
    rank: 21,
    cweId: 'CWE-306',
    name: 'Missing Authentication for Critical Function',
    score: 9.38,
    cveCount: 744,
    avgCVSS: 6.90,
  },
  {
    rank: 22,
    cweId: 'CWE-269',
    name: 'Improper Privilege Management',
    score: 8.92,
    cveCount: 636,
    avgCVSS: 7.15,
  },
  {
    rank: 23,
    cweId: 'CWE-401',
    name: 'Missing Release of Memory after Effective Lifetime',
    score: 8.70,
    cveCount: 772,
    avgCVSS: 6.15,
  },
  {
    rank: 24,
    cweId: 'CWE-190',
    name: 'Integer Overflow or Wraparound',
    score: 8.60,
    cveCount: 667,
    avgCVSS: 6.74,
  },
  {
    rank: 25,
    cweId: 'CWE-522',
    name: 'Insufficiently Protected Credentials',
    score: 8.54,
    cveCount: 283,
    avgCVSS: 7.97,
  },
];

/**
 * Get CWE rank from Top 25 list
 */
export function getCWERank(cweId: string): number | null {
  const entry = TOP_25_2024.find((e) => e.cweId === cweId);
  return entry ? entry.rank : null;
}

/**
 * Check if CWE is in Top 25
 */
export function isTop25CWE(cweId: string): boolean {
  return TOP_25_2024.some((e) => e.cweId === cweId);
}

/**
 * Get Top 25 entry by CWE ID
 */
export function getTop25Entry(cweId: string): Top25Entry | null {
  return TOP_25_2024.find((e) => e.cweId === cweId) || null;
}
